module.exports = __webpack_public_path__ + "static/img/loading.9b7ea625.svg";